import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ManageOutletHeader from "../../components/ManageOutlet/ManageOutletHeader";
import ManageOutletTable from "../../components/ManageOutlet/ManageOutletTable";
import ErrorSuccessModal from "../../components/Modal/ErrorSuccessModal";
import { getAllOutletsData } from "../../helper";
import { fetchAllOutlets } from "../../services/outletsService";

const CURRENT_PAGE = 1;
const LIMIT = 10;
const QUERY = "";

const ManageOutlet = () => {
  const [query, setQuery] = useState(QUERY);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(CURRENT_PAGE);
  const [isTableDataLoading, setTableLoader] = useState(false);
  const [totalOutlet, setTotalOutlet] = useState(0);
  const [data, setData] = useState([]);
  const [isFailureModal, setIsFailureModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    heading: "",
    subHeading: "",
  });

  const handleSearch = (value: string) => {
    setQuery(value);
    setCurrentPage(1);
    fetchOutlets(1, LIMIT, value);
  };
  const handleEdit = (id: string) => {
    navigate(`/admin/edit-outlet/${id}`);
  };
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    fetchOutlets(currentPage, LIMIT, query);
  }, [currentPage, query]);

  const fetchOutlets = async (
    activePage: number,
    limitCount: number,
    queryString: string
  ) => {
    setTableLoader(true);
    try {
      let { data } = await fetchAllOutlets(activePage, limitCount, queryString);
      if (data.code === 200) {
        setTableLoader(false);
        setTotalOutlet(data.count);
        setData(getAllOutletsData(data.data));
      }
    } catch (error: any) {
      setTableLoader(false);
      if (navigator.onLine) {
        setIsFailureModal(true);
        setErrorMessage({
          heading: "Something went wrong.",
          subHeading: error.message,
        });
      }
    }
  };
  return (
    <>
      <ManageOutletHeader onSearch={handleSearch} query={query} />
      <ManageOutletTable
        onPageChange={(page) => handlePageChange(page)}
        totalData={totalOutlet}
        currentPage={currentPage}
        rowsPerPage={LIMIT}
        data={data}
        onEdit={handleEdit}
        isTableDataLoading={isTableDataLoading}
      />
      {isFailureModal && (
        <ErrorSuccessModal
          variant="error"
          heading={errorMessage.heading}
          subHeading={errorMessage.subHeading}
          buttonLabel="Ok"
          setOpenOrClose={setIsFailureModal}
          onSubmit={() => setIsFailureModal(false)}
        />
      )}
    </>
  );
};

export default ManageOutlet;
